<!-- App.vue -->
<template>
  <div id="app">
  <van-tabs sticky animated swipeable>
  <van-tab title="DD" name="DD">
    <van-field
      v-model="keyword"
      label="Search"
      placeholder="Enter your search keyword"
      @input="handleInput"
    />
    <van-dropdown-menu v-show="show1">
      <van-dropdown-item :title='title1' @change='handelChange' :options="option1" get-container="#app" />
    </van-dropdown-menu>
      </van-tab>
      </van-tabs>
  </div>
</template>

<script>
import { Field, Tab, Tabs, DropdownMenu, DropdownItem } from 'vant';

export default {
  components: {
    [Field.name]: Field,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
  },
  data() {
    return {
      keyword: '',
      title1: '概念',
      option1: [],
      show1: false
    };
  },
  methods: {
    handleInput() {
        this.option1 = []
        let jia_index = this.keyword.lastIndexOf('+')
        let kong_index = this.keyword.lastIndexOf(' ')
        this.$axios.get('/api/user/concept/list?keyword='+this.keyword.substring(Math.max(jia_index, kong_index)+1, this.keyword.length))
          .then(response => {
            for (var i = 0; i < response.data['data'].length; i++) {
              this.option1[i] = {"text": response.data['data'][i], "value": response.data['data'][i]}
              if (i == 0) {
                this.title1 = response.data['data'][i]
              }
            }
            this.show1 = true
          })
          .catch(error => {
            this.handleException(error);
          });
    },
    handelChange(value){
      window.console.log('handelChange')
      this.title1 = this.option1.filter(item => item.value === value)[0].text
      if (this.keyword.lastIndexOf('+') == -1 & this.keyword.lastIndexOf(' ') == -1) {
        this.keyword = this.title1
      } else {
        let jia_index = this.keyword.lastIndexOf('+')
        let kong_index = this.keyword.lastIndexOf(' ')
        window.console.log(this.keyword.substring(0, Math.max(jia_index, kong_index)+1))
        this.keyword = this.keyword.substring(0, Math.max(jia_index, kong_index)+1) + this.title1
      }
    }

  }
};
</script>

<style>
#app {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
}
</style>
